// Helper til at vise DAR-adresse-modal med custom actions
// Usage: showDarAddressModal(suggestedAddress, actions, opts)
// actions: array af {label, classes, click}
// opts: {headline, extraContent, close}

import events from '../services/events';

export function showDarAddressModal(suggestedAddress, actions, opts = {}) {
  const addressHtml = `
    <div class="bg-[#f7f7fa] rounded-lg p-4 mb-4 leading-relaxed">
      <div><strong>Vejnavn:</strong> ${suggestedAddress.streetName} ${suggestedAddress.streetNumber}</div>
      ${suggestedAddress.floorNumber ? `<div><strong>Etage:</strong> ${suggestedAddress.floorNumber}</div>` : ''}
      ${suggestedAddress.side ? `<div><strong>Side:</strong> ${suggestedAddress.side}</div>` : ''}
      ${suggestedAddress.roomNumber ? `<div><strong>Nummer:</strong> ${suggestedAddress.roomNumber}</div>` : ''}
      <div><strong>Postnummer:</strong> ${suggestedAddress.postalCode}</div>
      <div><strong>By:</strong> ${suggestedAddress.city}</div>
      <div class="mt-2 text-xs text-[#666]">
        <span class="bg-[#e0e7ef] text-[#2a4b7c] px-2 py-0.5 rounded">Kilde: DAR</span>
      </div>
    </div>
  `;
  events.createModal({
    headline: opts.headline || 'Vi har fundet en gyldig adresse fra DAR',
    content:
      (opts.extraContent || "<span class='text-red-700 font-semibold'>Den adresse du har indtastet kunne ikke verificeres.</span><br>Vi har måske fundet din adresse i Danmarks Adresseregister (DAR).<br>Vil du bruge denne adresse i stedet for den, du har indtastet?<br><br>") +
      addressHtml,
    actions: actions,
    close: opts.close || function () {}
  });
}
